module.exports = __webpack_public_path__ + "static/image 4-57507d3e16263885528f8eb95e9af9f9.png";